/** @jsxImportSource @emotion/react */
"use client";

import Link from "next/link";
import Image from "next/image";
import { Box, Button, Typography } from "@mui/material";
import {
  previewSection,
  previewTitle,
  previewGrid,
  previewItem,
  imageWrapper,
  overlay,
  overlayText,
} from "./styles";

type Category = {
  slug: string;
  title: string;
  image: string;
};

export default function HomeCategoriesPreview({
  categories,
}: {
  categories: Category[];
}) {
  const topCategories = categories.slice(0, 3);

  if (topCategories.length === 0) return null;

  return (
    <Box component="section" css={previewSection}>
      <Typography variant="h2" css={previewTitle}>
        Famento Koleksiyonları
      </Typography>

      <Box css={previewGrid}>
        {topCategories.map((cat) => (
          <Link key={cat.slug} href={`/urunler/${cat.slug}`}>
            <Box css={previewItem}>
              <Box className="img-wrapper" css={imageWrapper}>
                <Image src={cat.image} alt={`“${cat.title}” preview`} fill />
              </Box>
              <Box css={overlay}>
                <Typography variant="h2" css={overlayText}>
                  {cat.title}
                </Typography>
              </Box>
            </Box>
          </Link>
        ))}
      </Box>

      <Box mt={4} textAlign="center">
        <Button href="/urunler" variant="outlined">
          Tüm Ürünleri Gör
        </Button>
      </Box>
    </Box>
  );
}
